// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"upDK9fw0SBRlQDjaiTI9J","Open":"_18rb-JbNLHH1D4hNOiZ76U","Close":"_3ko5Va8U50e878Eor-FBTb"};